export default "__VITE_ASSET__4GoBeb3e__"